import { useCallback, useState } from "react";

export function useBooleanState(initialValue: boolean) {
  const [state, setState] = useState<boolean>(initialValue);
  const toggle = useCallback(() => setState((prev) => !prev), []);
  return { state, toggle, setState };
}
